<template>
  <div class="wrapper order-wrapper order-list">
    <div class="order-tab">
      <div class="order-nav">
        <mt-navbar v-model="selected">
          <mt-tab-item
            v-for="item in header"
            :id="item.tradeState"
            :key="`order_tab_${item.tradeState}`"
          >{{item.name}}</mt-tab-item>
        </mt-navbar>
      </div>
    </div>
    <mt-button
      type="danger"
      style="width:100%;margin:10px 0;cursor:pointer;border-radius:0;"
      @click="logout"
      v-if="isTest"
    >退出登录</mt-button>
    <mt-tab-container v-model="selected">
      <mt-tab-container-item
        v-for="item in header"
        :id="item.tradeState"
        :key="`order_tab_${item.tradeState}`"
      >
        <InfiniteScrollOrderList :status="item.tradeState" :visible="selected === item.tradeState"></InfiniteScrollOrderList>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import InfiniteScrollOrderList from './InfiniteScrollOrderList'
import { getOrderListHeader } from '@/api/order'
import { share } from '@/utils/share'

export default {
  name: 'OrderList',
  components: { InfiniteScrollOrderList },
  metaInfo: { title: '我的订单' },
  data() {
    return {
      selected: '',
      visible: '',
      redirect_uri: '',
      header: [],
      isTest: process.env.ENV !== 'prod'
    }
  },
  methods: {
    getHeader() {
      getOrderListHeader().then(response => {
        this.header = this.header.concat(response.data.list || [])
      })
    },
    logout() {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      Cookies.remove('openId', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      window.wx.closeWindow()
      this.$router.push({
        path: 'login',
        query: { autologin: '0' }
      })
    }
  },
  created() {
    this.getHeader()
    // 分享语设置
    share({
      title: '在艺App',
      desc: '爱艺术的人都在这里',
      link: 'https://www.zai-art.com',
      imgUrl: 'https://img.zai-art.com/logo/512.png'
    })
  }
}
</script>
<style src='@/assets/css/order.css'></style>
